import { api } from "@/api/client";
import { convertToFormData, ServiceClient } from "@/util";

export type Renewal = {
  process: string;
  technique: string;
  testType: string;
  ndeMethod: string;
  acceptanceCriteria: string;
  result: string;
  ndeDate: string;
  weldDate: string;
  notes: string;
  attachment?: File;
  welders: RenewalWelder[];
};

export type RenewalWelder = {
  welderId: string;
  name: string;
  update: boolean;
  reinstatement: boolean;
};

export type RenewalAdvisoryRequest = {
  process: string;
  technique: string;
  welders: RenewalWelder[];
};

export function getAdvisories(renewal: RenewalAdvisoryRequest) {
  return api.post<string[]>("williams/renewals/advisories", renewal);
}

export function downloadAttachment(id: string) {
  ServiceClient.redirect(`williams/renewals/attachment/${id}`);
}

export function addRenewal(renewal: Renewal) {
  const formData = convertToFormData(renewal);
  return api.post("williams/renewals", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
